import React, { useState, useContext } from "react";
import { useEffect } from "react";
import img1 from "../../assets/ProductId/image 131.png";
import frame from "../../assets/ProductId/Frame.jpg";
import { ProductIdAddressSVG, ProductIdChatSVG, ProductIdFollowSVG, ProductIdInquiryPriceTagSVG, ProductIdInquirySVG, ProductIdPriceTagSVG, ProductIdProprietorSVG, ProductIdSellerCardRatingSVG, ProductIdSentInquiryTickSVG, ProductIdUnfollowSVG, StartOrderSVG } from "../../assets/svg/allSvg"
import CartPanel from "../../components/UI/CartPanel";
import ProductDescription from "../UI/ProductID/ProductDescription";
import CustomerReviews from "../UI/ProductID/CustomerReviews";

import { getAuth } from "@firebase/auth";
import { createInquiryApi } from "../../Apis/EnquiryApi";
import { UserAuthContext } from "../../App";
import { useNavigate, useParams } from "react-router-dom";
import {
  allProductByCategoryApi,
  toggleWishlistApi,
  wishlistApi,
} from "../../Apis/ProductApi";
import { CurrencyContext } from "../../provider/CurrencyProvider";


const ProductId = ({ productData, storeDetails, firstImage }) => {
  const auth = getAuth();
  const navigate = useNavigate();

  const [liked, setLiked] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showForm2, setShowForm2] = useState(false);
  const [showForm3, setShowForm3] = useState(false);
  const [showImage, setShowImage] = useState(img1);
  const [color, setColor] = useState(0);
  const [productTabs, setProductTabs] = useState(0);
  const [isFollowing, setIsFollowing] = useState(false);
  const [allProductsData, setAllProductsData] = useState([]);
  const [storeId, setStoreId] = useState([]);
  const { userUid } = useContext(UserAuthContext);
  const [showInquiryForm, setShowInquiryForm] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const { calculatedPrice, getCurrencySymbol } = useContext(CurrencyContext);



  const handleFollow = () => {
    setIsFollowing(!isFollowing);
  };

  const toggleNextButton = () => {
    const user = auth.currentUser;
    if (!user) {
      navigate("/login");
      return;
    }
    setShowForm2(true);
    setShowForm3(false);
  };

  const handleViewAllInquiries = () => {
    navigate("/orders/inquiry"); // Redirect to inquiries page
  };

  const handleViewProductId = (productId) => {
    navigate(`/productId/${productId}`); // Redirect to productID page
  };

  const [inqiuryContact, setInqiuryContact] = useState(
    auth.currentUser ? auth.currentUser.phoneNumber : ""
  );

 
  

  const toggleSubmitButton = async () => {
    // alert(productData?.productID);
    const res = await createInquiryApi(
      productData?.productID,
      auth.currentUser.uid,
      productData?.storeID,
      inquiryContant,
      inquiryQuantity,
      inquiryEmail,
      inqiuryContact
    );

    setShowForm2(false);
    setShowForm3(true);

    setInqiuryContact("");
    setInquiryQuantity("");
    setInquiryEmail("");
    setInquiryContant("");
  };

  const toggleBackToProductButton = () => {
    setShowForm2(false);
    setShowForm3(false);
  };

  const [imageList, setImageList] = useState([]);
  const [mainImage, setMainImage] = useState("");
  const [refersh, setRefresh] = useState(false);
  const [inquiryQuantity, setInquiryQuantity] = useState("");

  useEffect(() => {
    setImageList(productData?.images);

    // alert(firstImage);

    setShowImage(firstImage || "");
    // console.log("store details : ", storeDetails);
  }, [firstImage, productData]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const drawer = document.querySelector(".side-drawer");
      if (drawer && !drawer.contains(event.target) && isDrawerOpen) {
        setIsDrawerOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isDrawerOpen]);

  const getProductTitle = (title, isDesc = false) => {
    return title.slice(0, isDesc ? 30 : 10);
  };

  const toggleDrawer = () => {
    // setIsDrawerOpen(!isDrawerOpen);
    const user = auth.currentUser;
    if (!user) {
      navigate("/login");
      return;
    }
    setIsDrawerOpen(!isDrawerOpen);
  };

  // get productId passed from previous screen
  const param = useParams();

  const toggleLike = async () => {
    if (!userUid?.currentUser?.uid) {
      navigate("/login");
      return;
    }

    // toggle wishList (like) button
    await toggleWishlistApi(userUid?.currentUser?.uid, param?.productId, !liked);
    setRefresh(!refersh);
  };

  // check if user exist in WishList
  useEffect(() => {
    const getWhishData = async () => {
      const response = await wishlistApi(userUid?.currentUser?.uid);
      if (response?.wishList) {
        const likedExist = response?.wishList?.wishlistJson.includes(param?.productId);
        setLiked(likedExist);
      }
    };

    if (userUid?.currentUser?.uid)
      getWhishData();
  }, [userUid?.currentUser?.uid, refersh]);


  const handleCloseInquiryForm = () => {
    setShowInquiryForm(false);
    setSelectedProduct(null);
    setShowForm2(false);
  };

  const [inquiryContant, setInquiryContant] = useState("");

  const productTabsHeader = [
    "Product Description",
    "Customer Reviews",
    "Company Overview",
  ];

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await allProductByCategoryApi(productData?.categoryID);
        if (response?.products) {
          setAllProductsData(response.products.slice(0, 6));
        } else {
          setAllProductsData([]);
        }
      } catch (error) {
        console.error("Error fetching product data:", error);
        setAllProductsData([]);
      }
    }

    async function fetchId() {
      try {
        const response = await allProductByCategoryApi(productData?.categoryID);
        if (response?.products) {
          setStoreId(response.products.slice(0, 6));
        } else {
          setStoreId([]);
        }
      } catch (error) {
        console.error("Error fetching product data:", error);
        setStoreId([]);
      }
    }

    if (productData?.categoryID) {
      fetchData();
    }
    fetchId();
  }, [productData]);


  

  const [inquiryEmail, setInquiryEmail] = useState(
    auth.currentUser ? auth.currentUser.email : ""
  );

  const productTabContents = [
    {
      tab: <ProductDescription data={productData?.longDesc} />,
    },
    {
      tab: (
        <CustomerReviews
          productID={productData?.productID}
          storeName={storeDetails?.storeName}
        />
      ),
    },
    // {
    //   tab: <CompanyOverview data={storeDetails?.storeDesc} />,
    // },
  ];

  return (
    <>
      <div className="w-full h-auto bg-white">
        <div className="w-full lg:max-w-[1240px] p-4 lg:p-0 m-auto h-[570px] flex flex-row items-center justify-center">
          <div className="flex flex-col gap-y-[12px] w-full md:w-[363px]">
            <div className="md:w-[363px] w-full h-[388px] border rounded-[10px] p-[20px]">
              <div className="w-full h-[25px] flex items-center justify-end">
               <button
                  className={`flex items-center w-[38px] h-[38px] border justify-center rounded-full ${liked ? "bg-white text-[#FF6300]" : " text-gray-600"
                    }`}
                  onClick={toggleLike}
                >
                  {liked ? (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="w-6 h-6"
                      >
                        <path d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z" />
                      </svg>
                    </>
                  ) : (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                        />
                      </svg>
                    </>
                  )}
                </button>
              </div>

              {/* {console.log(productData?.image[0])} */}

              <div className="h-[320px] flex items-center justify-center">
                <img
                  // src={productData?.image[0]}
                  src={showImage}
                  alt="mainImg"
                  // className="w-[193px] h-[237px]"
                  className="w-[320px] h-[300px] object-fill"
                />
              </div>
            </div>

            <div className="flex flex-row gap-x-[12px]">
              {productData?.images?.map(
                (data, index) =>
                  data != "" && (
                    <button
                      onClick={() => {
                        setShowImage(data);
                        setColor(index);
                      }}
                      key={index}
                      style={{ borderColor: color === index && "#FF8100" }}
                      className="w-[82px] h-[77px] bg-white border-[2px] rounded-[5px] flex items-center justify-center"
                    >
                      <img src={data} alt={data} className="w-[70px] h-[70px]" />
                    </button>
                  )
              )}
            </div>
          </div>

          <div className="lg:w-[466px] h-[477px] flex flex-col ml-[31px]">
            <h2 className="lg:w-[466px] h-auto text-[#FF6300] font-semibold text-[18px]">
              {productData?.productTitle}...
            </h2>
            <div className="flex gap-x-[6px] items-center mt-[17px]">
              {ProductIdPriceTagSVG}
              <p className="w-auto h-[24px] font-semibold text-[16px]">
                Price: {getCurrencySymbol()}{" "} {calculatedPrice(productData?.minPrice)} / unit
              </p>
            </div>
            <div>
              <span className="inline-block text-black px-3 py-2 h-[37px] border rounded-[5px] font-semibold text-[14px] mt-[20px]">
                Category : {productData?.mainCategory}
              </span>
            </div>
            <div className="lg:w-[466px] h-[227px] leading-[28px] text-[14px] mt-[21px] overflow-y-scroll">
              <ul className="list-disc font-medium text-[14px]">
                <li>{productData?.shortDesc}</li>
              </ul>
            </div>
            <div className="flex h-[82px] items-end gap-x-[7px]">
              <button
                className="w-full lg:w-[129px] h-[42px] gap-x-[10px] bg-[#FF6300] text-white font-semibold text-[14px] rounded-[5px] flex items-center justify-center"
                onClick={toggleDrawer}
              >
                {StartOrderSVG}
                <p className="select-none">Start Order</p>
              </button>
              <div className="side-drawer">
                {isDrawerOpen && (
                  <CartPanel
                    isOpen={isDrawerOpen}
                    onClose={toggleDrawer}
                    image={productData?.images[0]}
                    name={productData?.productTitle}
                    productID={productData?.productID}
                    moq={productData?.moq}
                    sellerName={storeDetails?.storeName}
                    price={productData?.minPrice}
                    storeID={productData?.storeID}
                  />
                )}
              </div>
              <button
                className="w-full lg:w-[145px] h-[42px] gap-x-[10px] bg-white text-black font-semibold text-[14px] rounded-[5px] flex items-center justify-center border"
                onClick={toggleNextButton}
              >
                {ProductIdInquirySVG}

                <p className="select-none">Send Enquiry</p>
              </button>
              {showForm2 && (
                <>
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-[10px] w-[869px] h-[657px] flex flex-col">
                      <div className="w-full h-[202px] bg-[#F8F8F8] rounded-t-[10px] pt-[24px] px-[40px] flex flex-col">
                        <p className="w-[125px] h-[24px] font-semibold text-[16px]">
                          Product Inquiry
                        </p>
                        <hr className="w-[184px] h-[3px] rounded-full bg-[#FF6300] mt-[13px]" />

                        <div className="mt-[18px] flex flex-row gap-x-[21px]">
                          <div className="w-[118px] h-[98px] bg-white flex items-center justify-center rounded-[5px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
                            <img
                              src={productData?.images[0]}
                              alt=""
                              className="w-[48px] h-[60px]"
                            />
                          </div>

                          <div className="w-full flex justify-between">
                            <div className="flex flex-col gap-y-[11px] text-start items-start justify-center w-[500px]">
                              <p className="w-[500px] h-[21px] font-semibold text-[14px]">
                                {productData?.productTitle}
                              </p>
                              <p className="text-[12px] font-medium">
                                Seller : {storeDetails?.storeName}
                              </p>
                            </div>

                            <div className="flex flex-col gap-y-[9px] justify-center items-end w-[150px]">
                              <div className="w-[55px] h-[18px] font-medium text-[12px] gap-x-[5px] flex items-center justify-end">
                                {ProductIdInquiryPriceTagSVG}
                                <p className="">Price :</p>
                              </div>
                              <p className="w-auto h-[21px] font-semibold text-[14px] text-end">
                                {getCurrencySymbol()}{" "} {calculatedPrice(productData?.minPrice)} / unit
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="px-[40px] w-[869px] h-[455px] pt-[46px]">
                        <div className="flex flex-row gap-x-[22px]">
                          <div className="gap-y-[10px] flex flex-col">
                            <p className="w-[124px] h-[21px] font-semibold text-[14px] text-black">
                              Product Quantity
                            </p>
                            <input
                              type="text"
                              value={inquiryQuantity}
                              onChange={(e) => setInquiryQuantity(e.target.value)}
                              placeholder="Enter product quantity"
                              className="w-[248px] h-[41px] border rounded-[5px] placeholder:text-[#979797] placeholder:text-[14px] placeholder:font-medium p-[10px] font-medium text-[14px]"
                            />
                          </div>

                          <div className="gap-y-[10px] flex flex-col">
                            <p className="w-[124px] h-[21px] font-semibold text-[14px] text-black">
                              Email ID
                            </p>
                            <input
                              type="text"
                              value={inquiryEmail}
                              onChange={(e) => setInquiryEmail(e.target.value)}
                              placeholder="Enter your email ID"
                              className="w-[248px] h-[41px] border rounded-[5px] placeholder:text-[#979797] placeholder:text-[14px] placeholder:font-medium p-[10px] font-medium text-[14px]"
                            />
                          </div>

                          <div className="gap-y-[10px] flex flex-col">
                            <p className="w-[124px] h-[21px] font-semibold text-[14px] text-black">
                              Contact No.
                            </p>
                            <input
                              type="text"
                              value={inqiuryContact}
                              onChange={(e) => setInqiuryContact(e.target.value)}
                              placeholder="Enter your contact no."
                              className="w-[248px] h-[41px] border rounded-[5px] placeholder:text-[#979797] placeholder:text-[14px] placeholder:font-medium p-[10px] font-medium text-[14px]"
                            />
                          </div>
                        </div>

                        <div className="gap-y-[10px] flex flex-col mt-[28px]">
                          <p className="w-[50px] h-[21px] font-semibold text-[14px] text-black">
                            Inquiry
                          </p>
                          <textarea
                            name="Inquiry"
                            id="Inquiry"
                            rows={5}
                            value={inquiryContant}
                            onChange={(e) => setInquiryContant(e.target.value)}
                            placeholder="Tell us what else do you want to know about the product"
                            className="w-[789px] h-[149px] p-[10px] border rounded-[5px] placeholder:text-[#979797] placeholder:text-[14px] placeholder:font-medium font-medium text-[14px] text-black resize-none"
                          ></textarea>
                        </div>

                        <div className="flex items-center justify-center gap-x-[19px] w-full h-[42px] flex-row mt-[50px]">
                          <button
                            className="w-[162px] h-[42px] bg-[#FF6300] font-semibold text-[14px] rounded-[5px] text-white "
                            onClick={toggleSubmitButton}
                          >
                            Send Inquiry
                          </button>
                          <button
                            className="w-[120px] h-[42px] rounded-[5px] text-black font-semibold text-[14px] border"
                            onClick={handleCloseInquiryForm}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {showForm3 && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-[10px] w-[869px] h-[434px] flex flex-col pt-[65px] pb-[51px] items-center justify-center gap-y-[32px]">
                    <p className="w-[98px] h-[98px] bg-[#0097B2] rounded-full flex items-center justify-center">
                      {ProductIdSentInquiryTickSVG}
                    </p>
                    <h3 className="w-[113px] h-[24px] font-semibold text-[16px] text-black text-start">
                      Inquiry Sent !!
                    </h3>
                    <p className="w-[305px] h-[52px] font-medium text-[14px] text-black text-center">
                      Your inquiry has been sent to the seller. We will notify you
                      once the seller responds.
                    </p>
                    <button
                      className="w-[162px] h-[42px] bg-[#FF6300] rounded-[5px] text-white font-semibold text-[14px]"
                      onClick={handleViewAllInquiries}
                    >
                      View All Inquiries
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="w-[302px] h-[477px] bg-white rounded-[10px] border p-[16px] lg:flex hidden flex-col ml-[78px] ">
            <div className="w-full h-[24px] flex items-center justify-between">
              <p className="w-[105px] h-[24px] font-semibold text-[16px] text-black">
                Seller Details
              </p>
              <div className="gap-x-[4px] flex items-center justify-end">
                {ProductIdSellerCardRatingSVG}
                <p className="w-[22px] h-[21px] font-semibold text-[14px] text-black">
                  4.5
                </p>
              </div>
            </div>

            <hr className="bg-[#FF6300] w-[163px] h-[3px] rounded-full" />

            <div className="w-full flex items-center justify-start mt-[18px] gap-x-[6px]">
              <p className="w-auto h-auto text-black font-semibold text-[15px]">
                {storeDetails?.storeName}
              </p>
              {storeDetails.isVerified == 1 && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="w-4 h-4 text-[#72C62F]"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                    clip-rule="evenodd"
                  />
                </svg>
              )}
            </div>

            <div className="mt-[11px]">
              <img src={frame} alt="frame" className="w-[85px] h-[27px]" />
            </div>

            <div className="flex gap-x-[6px] mt-[24px]">
              {ProductIdProprietorSVG}
              <p className="w-[84px] h-[23px] font-semibold text-[15px] text-black">
                Proprietor :
              </p>
            </div>

            <p className="text-[14px] text-black font-medium w-auto h-[21px] mt-[6px]">
              Mr. {storeDetails?.name}
            </p>

            <div className="flex gap-x-[6px] mt-[27px]">
              {ProductIdAddressSVG}

              <p className="w-[63px] h-[23px] font-semibold text-[15px] text-black">
                Address
              </p>
            </div>

            <p className="w-[250px] h-[78px] font-medium text-[14px] leading-[23px] mt-[7px]">
              {storeDetails?.storeAddress}
            </p>

            <button
              className="flex gap-x-[8px] items-center justify-center font-semibold text-[14px] border w-[270px] h-[42px] rounded-[5px] mt-[35px]"
              onClick={handleFollow}
            >
              <p>
                {isFollowing ? (
                  "Unfollow"
                ) : (
                  <div className="flex gap-x-[8px]">
                    {ProductIdFollowSVG}
                    <p>Follow</p>
                  </div>
                )}
              </p>
            </button>

            <button className="flex gap-x-[8px] items-center justify-center font-semibold text-[14px] border w-[270px] h-[42px] rounded-[5px] text-white mt-[13px] bg-[#FF6300]">
              {ProductIdChatSVG}
              <p>Chat</p>
            </button>
          </div>
        </div>
      </div>


      <div className="w-full h-auto">
        <div className="max-w-[1240px] h-[48px] m-auto mt-[34px] font-semibold text-[16px] border-b-[2px] border-[#D7D7D7]">
          {productTabsHeader?.map((tab, index) => (
            <button
              key={index}
              className={`-mb-px border-b-[3px] transition-all duration-300 w-[230px] h-[48px] ${productTabs === index
                ? "border-[#FF6300] text-black font-semibold text-[16px]"
                : "border-transparent text-black font-semibold text-[16px]"
                }`}
              onClick={() => setProductTabs(index)}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className="max-w-[1240px] m-auto h-auto">
          {productTabContents?.map((content, index) => (
            <div
              key={index}
              className={`transition-opacity duration-300 ${productTabs === index ? "opacity-100" : "opacity-0 absolute"
                }`}
            >
              {productTabs === index && <div>{content.tab}</div>}
            </div>
          ))}
        </div>
      </div>

      <div className="w-full h-[954px]">
        <div className="max-w-[1240px] m-auto mt-[47px]">
          <div className="font-semibold text-[18px] text-black  w-full flex items-center justify-start">
            Related Products
          </div>
          <hr className="w-[192px] h-[4px] bg-[#FF6300] mt-[10px] rounded-full" />
          <p className="w-[251px] h-[30px] text-[14px] mt-[10px]">
            Find products from similar category
          </p>

          <div className="w-[1240px] h-[325px] bg-white rounded-[10px] mt-[17px] py-[31px] px-[50px] flex shadow-[0_0px_0px_1px_rgba(0,0,0,0.10)]">
            <div className="flex gap-x-[24px] flex-row">
              {allProductsData &&
                allProductsData?.map((item) => (
                  <button className="bg-[#F8F8F8] h-[263px] w-[170px] rounded-[10px] shadow-[0_0px_0px_1px_rgba(0,0,0,0.10)] text-left" onClick={() => handleViewProductId(item.productID)}>
                    <div className="product-wraps mt-[10px] mx-[12px]">
                      <img
                        className="h-[100px] w-[146px] rounded-[5px] mb-[15px]"
                        src={item.images[0]}
                        alt="productImg1"

                      />
                      <hr className="mb-[16px] h-[2px] w-[146px] bg-[#B8B8B8] opacity-35" />
                      <div>
                        <div className="productName w-auto h-[17px] text-[16px] font-semibold leading-[16px] mb-[15px]">
                          {getProductTitle(item.productTitle)}
                        </div>
                        <div className="productPrice w-auto h-[21px] text-[14px] font-medium leading-[20px] mb-[9px]">
                          {getCurrencySymbol()}{" "} {calculatedPrice(item.maxPrice)}
                        </div>
                        <div className="productDesc text-[14px] leading-[20px] w-auto h-[48px]">
                          {/* {getProductTitle(item.shortDesc, true)} */}
                          {getProductTitle(item.shortDesc.slice(0, 25), true)}
                          ...
                        </div>
                      </div>
                    </div>
                  </button>
                ))}
            </div>
          </div>
        </div>

        <div className="max-w-[1240px] m-auto mt-[47px]">
          <div className="font-semibold text-[18px] text-black  w-full flex items-center justify-start">
            Seller’s popular products
          </div>
          <hr className="w-[283px] h-[4px] bg-[#FF6300] mt-[10px] rounded-full" />
          <p className="w-[310px] h-[30px] text-[14px] mt-[10px]">
            Find other popular products from the seller
          </p>

          <div className="w-[1240px] h-[325px] bg-white rounded-[10px] mt-[17px] py-[31px] px-[50px] flex shadow-[0_0px_0px_1px_rgba(0,0,0,0.10)]">
            <div className="flex gap-x-[24px] flex-row">
              {storeId &&
                storeId?.map((item) => (
                  <button className="bg-[#F8F8F8] h-[263px] w-[170px] rounded-[10px] shadow-[0_0px_0px_1px_rgba(0,0,0,0.10)] text-left" onClick={() => handleViewProductId(item.productID)}>
                    <div className="product-wraps mt-[10px] mx-[12px]">
                      <img
                        className="h-[100px] w-[146px] rounded-[5px] mb-[15px]"
                        src={item.images[0]}
                        alt="productImg1"
                      />
                      <hr className="mb-[16px] h-[2px] w-[146px] bg-[#B8B8B8] opacity-35" />
                      <div>
                        <div className="productName w-auto h-[17px] text-[16px] font-semibold leading-[16px] mb-[15px]">
                          {getProductTitle(item.productTitle)}
                        </div>
                        <div className="productPrice w-auto h-[21px] text-[14px] font-medium leading-[20px] mb-[9px]">
                          {getCurrencySymbol()}{" "} {calculatedPrice(item.maxPrice)}
                        </div>
                        <div className="productDesc text-[14px] leading-[20px] w-auto h-[48px]">
                          {/* {getProductTitle(item.shortDesc, true)} */}
                          {getProductTitle(item.shortDesc.slice(0, 25), true)}
                          ...
                        </div>
                      </div>
                    </div>
                  </button>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductId;
